(() => {
  'use strict';
  const root = document.getElementById('monolith-wishlist-dialog');
  const config = document.getElementById('monolith-wishlist-labels');
  if (!root || !config) return;
  if (root.dataset.mwInitialized) return;
  root.dataset.mwInitialized = 'true';
  const t = JSON.parse(config.textContent);
  const productNode = document.getElementById('monolith-wishlist-product');
  const current = productNode ? JSON.parse(productNode.textContent) : null;
    if (current) document.body.classList.add('mw-product-page');
    const customerId = JSON.parse(document.getElementById('monolith-wishlist-customer')?.textContent || '{"id":null}').id;
  const key = `monolith-wishlist-v1:${customerId || 'guest'}`;
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.8 8.1c0 4.2-8.8 10.3-8.8 10.3S3.2 12.3 3.2 8.1a4.3 4.3 0 0 1 8.8-1.4 4.3 4.3 0 0 1 8.8 1.4Z"/></svg>';
  const path = window.Shopify?.routes?.root || '/';
  const cacheKey = `monolith-wishlist-server-v1:${customerId || 'guest'}`;
  const deviceKey = 'monolith-wishlist-device-v1';
  let device, sessionToken, ready = false, busy = false, syncError = false;
  let socialCount = null;
  let items = [];
  const readCache = name => {
    try { const data = JSON.parse(localStorage.getItem(name) || '[]'); return Array.isArray(data) ? data : []; }
    catch { return []; }
  };
  const legacyCount = Math.max(readCache(key).length, !customerId ? readCache('monolith-wishlist-v1').length : 0);
  const language = (document.documentElement.lang || 'en').split('-')[0];
  const messages = {
    de: ['Deine Wunschliste wird gespeichert. Mit Kundenkonto ist sie auch auf anderen Geräten verfügbar.', 'Deine bisherige Browserliste bleibt erhalten. Ihre Übernahme steht noch aus.', 'Die Wunschliste konnte nicht geladen oder gespeichert werden. Bitte versuche es erneut.'],
    fr: ['Votre liste est enregistrée. Avec un compte client, elle est disponible sur vos autres appareils.', 'Votre ancienne liste du navigateur est conservée. Son transfert reste à effectuer.', 'Impossible de charger ou enregistrer la liste. Réessayez.'],
    it: ['La lista viene salvata. Con un account cliente è disponibile anche su altri dispositivi.', 'La vecchia lista del browser è conservata. Il trasferimento è ancora da effettuare.', 'Impossibile caricare o salvare la lista. Riprova.'],
    es: ['Tu lista se guarda. Con una cuenta está disponible en otros dispositivos.', 'Tu antigua lista del navegador se conserva. Su transferencia está pendiente.', 'No se pudo cargar o guardar la lista. Inténtalo de nuevo.'],
    pl: ['Lista jest zapisywana. Z kontem klienta jest dostępna na innych urządzeniach.', 'Poprzednia lista w przeglądarce została zachowana. Przeniesienie jest w toku.', 'Nie udało się wczytać lub zapisać listy. Spróbuj ponownie.'],
    sv: ['Listan sparas. Med ett kundkonto finns den även på andra enheter.', 'Din tidigare webbläsarlista är bevarad. Överföringen återstår.', 'Det gick inte att läsa in eller spara listan. Försök igen.'],
    fi: ['Lista tallennetaan. Asiakastilillä se on käytettävissä myös muilla laitteilla.', 'Vanha selaimen lista on säilytetty. Siirto on vielä tekemättä.', 'Listaa ei voitu ladata tai tallentaa. Yritä uudelleen.'],
    nl: ['Je lijst wordt opgeslagen. Met een klantaccount is deze ook op andere apparaten beschikbaar.', 'Je oude browserlijst blijft bewaard. De overdracht moet nog gebeuren.', 'De lijst kon niet worden geladen of opgeslagen. Probeer opnieuw.'],
    en: ['Your wishlist is saved. With a customer account it is available on other devices.', 'Your previous browser list is preserved. Its transfer is still pending.', 'The wishlist could not be loaded or saved. Please try again.']
  }[language] || ['Your wishlist is saved. With a customer account it is available on other devices.', 'Your previous browser list is preserved. Its transfer is still pending.', 'The wishlist could not be loaded or saved. Please try again.'];
  const validId = value => /^[1-9][0-9]{0,19}$/.test(String(value || ''));
 const validHandle = value =>
  typeof value === 'string'
  && /^[\p{L}\p{M}\p{N}\p{S}_-]{1,255}$/u.test(value)
  && !/[\s~<>]/u.test(value);

const validEntry = entry =>
  entry
  && validHandle(entry.handle)
  && validId(entry.product_id)
  && validId(entry.variant_id);
  const cache = () => { try { localStorage.setItem(cacheKey, JSON.stringify(items)); } catch {} };
  const getDevice = () => {
    if (device) return device;
    try {
      device = localStorage.getItem(deviceKey);
      if (!/^[a-f0-9]{64}$/.test(device || '')) {
        device = Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('');
        localStorage.setItem(deviceKey, device);
      }
      if (localStorage.getItem(deviceKey) !== device) throw new Error('storage');
    } catch (error) { device = undefined; throw error; }
    return device;
  };
  const request = async (endpoint, options = {}) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`/apps/monolith-wishlist${endpoint}`, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const data = await response.json();
      if (!response.ok) { const error = new Error('wishlist'); error.status = response.status; throw error; }
      return data;
    } finally { clearTimeout(timeout); }
  };
  const post = async (endpoint, payload) => {
    const send = async refresh => {
      const guest = getDevice();
      if (!sessionToken || refresh) {
        const session = await request(`/session?guest_id=${guest}`);
        if (typeof session.token !== 'string' || !session.token) throw new Error('session');
        sessionToken = session.token;
      }
      return request(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...payload, guest_id: guest, token: sessionToken }) });
    };
    try { return await send(false); }
    catch (error) { if (error.status === 403) return send(true); throw error; }
  };
  const loadServer = async () => {
    const data = await request(`/list?guest_id=${getDevice()}`);
    if (!Array.isArray(data.items) || data.items.some(entry => !validEntry(entry))) throw new Error('list');
    items = data.items.map(entry => ({ productId: String(entry.product_id), variantId: String(entry.variant_id), handle: entry.handle }));
    ready = true; syncError = false; cache(); update();
  };
  let shared = null;
  const params = new URLSearchParams(location.search);
  const encoded = params.get('monolith_wishlist');
  if (encoded && encoded.length < 3500) shared = encoded.split(',').map(part => { const [handle, variantId] = part.split('~'); return validHandle(handle) ? { handle, variantId: /^\d+$/.test(variantId || '') ? variantId : null } : null; }).filter(Boolean);
  const status = root.querySelector('.mw-status');
  root.querySelector('[data-mw-close]').setAttribute('aria-label', t.close);
  const list = root.querySelector('.mw-items');
  const counts = document.querySelectorAll('[data-mw-count]');
  const launches = document.querySelectorAll('[data-mw-open]');
  const showSocialCount = value => {
    const count = Math.max(Number(value), Number(current?.socialCount) || 0, Number(socialCount) || 0);
    if (!Number.isSafeInteger(count) || count < 0) return;
    socialCount = count;
    document.querySelectorAll('.mw-product-button').forEach(button => {
      let badge = button.querySelector('[data-mw-social-count]');
      if (!badge) {
        badge = document.createElement('span');
        badge.dataset.mwSocialCount = '';
        button.append(badge);
      }
      badge.textContent = `(${new Intl.NumberFormat(document.documentElement.lang || 'de').format(count)})`;
    });
  };
  if (current?.socialCount != null) showSocialCount(current.socialCount);
  const selectedVariant = button => button?.closest('.product__info-container')?.querySelector('.main-product-form input.product-variant-id')?.value || current?.variantId;
  const update = () => {
    counts.forEach(count => { if (count.textContent !== String(items.length)) count.textContent = String(items.length); count.hidden = !items.length; });
    launches.forEach(launch => launch.setAttribute('aria-label', `${t.title}: ${items.length} ${t.count}`));
    document.querySelectorAll('[data-mw-handle]').forEach(button => {
      const active = items.some(x => x.handle === button.dataset.mwHandle && (!button.classList.contains('mw-product-button') || String(x.variantId) === String(selectedVariant(button))));
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? t.saved : t.save);
      button.disabled = busy || !ready || Boolean(shared);
      if (button.classList.contains('mw-product-button')) {
        const label = active ? t.saved : t.save;
        const labelNode = button.querySelector('span:not([data-mw-social-count])');
        if (labelNode && labelNode.textContent !== label) labelNode.textContent = label;
      }
    });
  };
  const reportError = () => { syncError = true; status.textContent = messages[2]; if (!root.open) { root.showModal(); render(); } };
  const urlFor = handle => `${path}products/${encodeURIComponent(handle)}`;
  const fetchProduct = async handle => {
    const response = await fetch(`${urlFor(handle)}.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('product');
    return response.json();
  };
  const normalize = (product, variantId) => {
    const variants = product.variants || [];
    const variant = variantId
      ? variants.find(x => String(x.id) === String(variantId))
      : variants[0];

    const imageSrc = value =>
      typeof value === 'string' ? value : value?.src || value?.url || '';

    const variantTitle = variant?.public_title || variant?.title || '';
    const suffix = variantTitle && variantTitle !== 'Default Title'
      ? ` – ${variantTitle}`
      : '';

    const url = urlFor(product.handle);

    return {
      productId: String(product.id),
      handle: product.handle,
      variantId: String(variant?.id || variantId || ''),
      title: `${product.title}${suffix}`,
      image: imageSrc(variant?.featured_image)
        || imageSrc(variant?.featured_media?.preview_image)
        || imageSrc(product.featured_image)
        || imageSrc(product.image),
      price: variant?.price ?? product.price,
      available: Boolean(variant?.available),
      url: variant
        ? `${url}?variant=${encodeURIComponent(String(variant.id))}`
        : url
    };
  };
  const toggle = async (handle, variantId) => {
    if (busy || shared) return;
    busy = true; update();
    status.textContent = t.loading;
    try {
      if (!ready) await loadServer();
      const match = items.find(entry => entry.handle === handle && (!variantId || String(entry.variantId) === String(variantId)));
      const data = match || normalize(await fetchProduct(handle), variantId);
      if (!validId(data.productId) || !validId(data.variantId)) throw new Error('product');
      const result = await post('/save', { operation: match ? 'remove' : 'add', product_id: data.productId, variant_id: data.variantId, handle });
      if (result.saved !== !match) throw new Error('save');
      items = match ? items.filter(entry => entry !== match) : [{ ...data, handle }, ...items];
      cache(); syncError = false;
      if (String(current?.id) === String(data.productId)) showSocialCount(result.count);
      if (root.open && !shared) await render();
      else status.textContent = '';
    } catch { reportError(); }
    finally { busy = false; update(); }
  };
  const makeButton = (className, handle, variantId, fallback) => {
    const button = document.createElement('button');
    button.type = 'button'; button.dataset.mwBound = 'true'; button.className = className; button.dataset.mwHandle = handle;
    button.innerHTML = `${icon}${className === 'mw-product-button' ? '<span></span>' : ''}`;
    button.addEventListener('click', event => {
      event.preventDefault(); event.stopPropagation();
      const selected = className === 'mw-product-button' ? selectedVariant(button) : variantId;
      toggle(handle, selected, className === 'mw-product-button' ? null : fallback);
    });
    return button;
  };
  const productButton = () => {
    if (!current) return;
    const existing = document.querySelector('.mw-product-button');
    if (existing) {
      if (existing.dataset.mwBound) return;
      existing.dataset.mwBound = 'true';
      existing.dataset.mwHandle = current.handle;
      existing.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        const selected = selectedVariant(existing);
        toggle(current.handle, selected);
      });
      update();
      if (socialCount != null) showSocialCount(socialCount);
      return;
    }
    const box = document.querySelector('.product__blocks, .product__info-wrapper, .product-info, .product__info-container');
    if (!box) return;
    const target = box.querySelector('form[action*="/cart/add"], product-form, .product-form') || box.querySelector('.product__price, .price');
    const button = makeButton('mw-product-button', current.handle, current.variantId);
    if (target) target.before(button); else box.append(button);
    update();
    if (socialCount != null) showSocialCount(socialCount);
  };
  const cards = () => {
    document.querySelectorAll('.product-card, .foxify-product-card, .f\\:product-card').forEach(card => {
      const existing = card.querySelector('.mw-card-button');
      if (existing) {
        if (!existing.dataset.mwBound) {
          existing.dataset.mwBound = 'true';
          existing.addEventListener('click', event => {
            event.preventDefault(); event.stopPropagation();
            toggle(existing.dataset.mwHandle, existing.dataset.mwVariant);
          });
        }
        return;
      }
      const image = card.querySelector('.product-card__image-wrapper, .f\\:product-card__media, .pcard__media') || card;
      const link = image.querySelector('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const handle = link.href.split('/products/')[1]?.split(/[?#/]/)[0];
      if (!handle || !validHandle(handle)) return;
      const button = makeButton('mw-card-button', handle, new URL(link.href).searchParams.get('variant'));
      if (getComputedStyle(image).position === 'static') image.style.position = 'relative';
      image.append(button);
    });
    productButton(); update();
  };
  const money = cents => { try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(Number(cents) / 100); } catch { return ''; } };
  const itemNode = item => {
    const row = document.createElement('div'); row.className = 'mw-item';
    const img = document.createElement('img'); img.loading = 'lazy'; img.alt = ''; if (item.image) img.src = item.image;
    const info = document.createElement('div');
    const title = document.createElement('a'); title.className = 'mw-item__title'; title.href = item.url || urlFor(item.handle); title.textContent = item.title || item.handle;
    const price = document.createElement('p'); price.className = 'mw-item__price'; price.textContent = item.available ? money(item.price) : t.unavailable;
    const actions = document.createElement('div'); actions.className = 'mw-item__actions';
    const cart = document.createElement('button'); cart.type = 'button'; cart.textContent = t.cart; cart.disabled = !item.available || !item.variantId;
    cart.addEventListener('click', () => addCart([{ id: item.variantId, quantity: 1 }]));
    actions.append(cart);
    if (!shared) {
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.mwRemove = ''; remove.textContent = t.remove;
      remove.addEventListener('click', () => toggle(item.handle, item.variantId)); actions.append(remove);
    }
const imageLink = document.createElement('a');
imageLink.href = title.href;
imageLink.setAttribute('aria-label', title.textContent);
imageLink.style.display = 'block';
imageLink.append(img);
info.append(title, price, actions);
row.append(imageLink, info);
return row;  };
  const addCart = async lines => {
    if (!lines.length) return;
    status.textContent = t.loading;
    try {
      const response = await fetch(`${path}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }), credentials: 'same-origin' });
      if (!response.ok) throw new Error('cart');
      if (typeof window.opusOpen === 'function') {
  status.textContent = '';
  root.close();
  window.opusOpen();
} else {
  location.href = `${path}cart`;
}
    } catch { status.textContent = t.error; }
  };
  let renderToken = 0;
  const render = async () => {
    const token = ++renderToken;
    const source = shared || items;
    root.querySelector('#mw-title').textContent = shared ? t.shared : t.title;
    root.querySelector('.mw-notice').textContent = shared ? '' : [messages[0], legacyCount ? messages[1] : ''].filter(Boolean).join(' ');
    root.querySelector('[data-mw-share]').textContent = t.share;
    root.querySelector('[data-mw-add-all]').textContent = t.add_all;
    root.querySelector('.mw-actions').hidden = !source.length || Boolean(shared);
    list.replaceChildren(); status.textContent = syncError ? messages[2] : (!ready && !shared ? t.loading : source.length ? t.loading : t.empty);
    if (!source.length) return;
    const products = await Promise.all(source.map(async entry => {
      try { return normalize(await fetchProduct(entry.handle), entry.variantId); }
      catch { return { ...entry, available: false, url: urlFor(entry.handle) }; }
    }));
    if (!root.open || token !== renderToken) return;
    status.textContent = syncError ? messages[2] : '';
    products.forEach(item => list.append(itemNode(item)));
    root.querySelector('[data-mw-add-all]').onclick = () => addCart(products.filter(x => x.available && x.variantId).map(x => ({ id: x.variantId, quantity: 1 })));
  };
  const openDrawer = async () => {
    if (!root.open) root.showModal();
    if (!shared && !busy) { try { await initial; await loadServer(); } catch { syncError = true; } }
    render();
  };
  launches.forEach(launch => launch.addEventListener('click', openDrawer));
  document.addEventListener('variant:changed', update);
  root.querySelector('[data-mw-close]').addEventListener('click', () => root.close());
  root.addEventListener('click', event => { if (event.target === root) root.close(); });
  root.querySelector('[data-mw-share]').addEventListener('click', async () => {
    const link = new URL(path, location.origin); link.searchParams.set('monolith_wishlist', items.map(x => `${x.handle}~${x.variantId}`).join(','));
    if (link.href.length > 3500) { status.textContent = t.error; return; }
    try { await navigator.clipboard.writeText(link.href); status.textContent = t.copied; }
    catch { status.textContent = link.href; }
  });
  window.addEventListener('storage', async event => {
    if (event.key !== cacheKey || busy || shared) return;
    try { await initial; await loadServer(); if (root.open) render(); } catch { syncError = true; if (root.open) render(); }
  });
  const initial = (async () => {
    try {
      if (shared) { ready = true; update(); return; }
      if (customerId && readCache('monolith-wishlist-server-v1:guest').length) {
        await post('/merge', {});
        try { localStorage.removeItem('monolith-wishlist-server-v1:guest'); } catch {}
      }
      await loadServer();
      if (current?.id) {
        try { const data = await request(`/count?product_id=${encodeURIComponent(String(current.id))}`); showSocialCount(data.count); } catch {}
      }
    } catch { ready = false; syncError = true; }
    update();
    if (root.open) render();
  })();
  let scheduled = false;
  new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; cards(); }); } }).observe(document.body, { childList: true, subtree: true });
  cards();
  document.querySelector('[data-mw-page-open]')?.addEventListener('click', openDrawer);
  if (shared || document.body.classList.contains('swym')) openDrawer();
})();
